import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Dropdown from './src/dropdown.vue'
import DropdownItem from './src/dropdown-item.vue'
import DropdownMenu from './src/dropdown-menu.vue'

export const JdDropdown = withInstall(Dropdown, {
  DropdownItem,
  DropdownMenu,
})
export default JdDropdown
export const JdDropdownItem = withNoopInstall(DropdownItem)
export const JdDropdownMenu = withNoopInstall(DropdownMenu)
export * from './src/dropdown'
export * from './src/instance'
export * from './src/tokens'
